import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import {
  selectIsAuthorized,
  selectIsSessionRequested,
  setupProfile,
} from '@/entities/session';
import { toSafeRedirectPath } from '@/shared/lib';
import { useAppDispatch, useAppSelector } from '@/shared/model';
import { useCrossTabAuthReload } from '../../model/useCrossTabAuthReload';

export function GuestGuard() {
  const dispath = useAppDispatch();
  const isSessionRequested = useAppSelector(selectIsSessionRequested);
  const isAuthorized = useAppSelector(selectIsAuthorized);
  const location = useLocation();

  useCrossTabAuthReload();

  useEffect(() => {
    if (isSessionRequested) {
      return;
    }

    dispath(setupProfile());
  }, [isSessionRequested, dispath]);
  if (isAuthorized) {
    const target = toSafeRedirectPath(location.state?.from);

    return <Navigate to={target} replace />;
  }

  return <Outlet />;
}
